import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class ZohoSignService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getMerchantContractFormUrl(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/ZohoSign/GetMerchantContractFormUrl', data, messageService);
    }
}
